export type WorkingMode = 'custom' | 'classic_essays' | 'ai_tutor_oral';

export type WorkingModeLockKey =
  | 'module.taskCompletionPolicy'
  | 'module.autogradeOnSubmission'
  | 'module.examinationBasis'
  | 'task.completionPolicyOverride'
  | 'task.evaluationMode'
  | 'task.gradingRelevant';

export const GSS_EVENT_KIND_ID = 'group_study_60_15';

export function getWorkingModeModeLabelKey(
  workingMode: WorkingMode,
): string {
  switch (workingMode) {
    case 'classic_essays':
      return 'lecturer.moduleEditor.workingMode.modes.classicEssays';
    case 'ai_tutor_oral':
      return 'lecturer.moduleEditor.workingMode.modes.aiTutorOral';
    default:
      return 'lecturer.moduleEditor.workingMode.modes.custom';
  }
}

export function getWorkingModeFieldLock(args: {
  workingMode: WorkingMode | null | undefined;
  field: WorkingModeLockKey;
  taskType?: string | null;
  eventKindId?: string | null;
}): { locked: boolean; modeLabelKey?: string } {
  const {
    workingMode, field, taskType, eventKindId,
  } = args;

  if (!workingMode || workingMode === 'custom') {
    return { locked: false };
  }

  const modeLabelKey = getWorkingModeModeLabelKey(workingMode);

  if (workingMode === 'classic_essays') {
    if (field === 'module.taskCompletionPolicy' || field === 'module.examinationBasis') {
      return { locked: true, modeLabelKey };
    }
    // Autograde is irrelevant under Classic essays — leave editable.
    if (field === 'task.evaluationMode' && taskType === 'essay') {
      return { locked: true, modeLabelKey };
    }
    if (field === 'task.completionPolicyOverride') {
      const isGss = taskType === 'event' && eventKindId === GSS_EVENT_KIND_ID;
      if (isGss) {
        return { locked: true, modeLabelKey };
      }
    }
    return { locked: false };
  }

  if (workingMode === 'ai_tutor_oral') {
    if (
      field === 'module.taskCompletionPolicy'
      || field === 'module.autogradeOnSubmission'
      || field === 'module.examinationBasis'
    ) {
      return { locked: true, modeLabelKey };
    }

    if (field === 'task.completionPolicyOverride') {
      const isEssay = taskType === 'essay';
      const isGss = taskType === 'event' && eventKindId === GSS_EVENT_KIND_ID;
      if (isEssay || isGss) {
        return { locked: true, modeLabelKey };
      }
    }

    if (field === 'task.evaluationMode' && taskType === 'essay') {
      return { locked: true, modeLabelKey };
    }

    if (field === 'task.gradingRelevant' && taskType === 'essay') {
      return { locked: true, modeLabelKey };
    }
  }

  return { locked: false };
}
